import axios from "axios";
import { Message, MessageBox } from "element-ui";
import store from "../store";

// axios.defaults.baseURL = "https://hou.fangdaruanjian.cn/";  // 正式  企讯客

// axios.defaults.baseURL = "https://testapi.fangdaruanjian.cn:8088/";  // 测试

axios.defaults.baseURL = "https://api.jiankangxuexi.com/";  // 逆根香

// axios.defaults.baseURL = "https://api.yxz518.cn/"; //长沙易行者yxz

// axios.defaults.baseURL: "https://dlapi.fangdaruanjian.cn/"; //元多多

// axios.defaults.baseURL = "https://api.2006fd.cn/";  // 0423代理商合伙

// axios.defaults.baseURL = "https://api.phonevip.cn/";  // 企信云 自营代理商

// 响应
axios.interceptors.response.use(res => {
    if (res.status != 200) {
        Message.error(('接口调用失败'))
        return res.data
    } else {
        console.log(res.data.msg);
        if (res.data.msg == "登录过期,请重新登录!") {
            store.commit('setIsValid', false);
        }
        return res.data
    }
}, err => {
    console.log('登录信息已过期' + err);
    store.commit('setIsValid', false);
})
// 请求
axios.interceptors.request.use(req => {
    req.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=UTF-8'
    req.headers["X-Requested-With"] = 'XMLHttpRequest'
    
    return req
})

export default {
    baseUrl: axios.defaults.baseURL,

    platformName: "逆根香", //正式服
    corporateName: '成都方大软件有限公司', //正式服
    // platformName: "企讯客", //正式服
    // corporateName: '成都方大软件有限公司', //正式服
    // platformName: "话圆圈",
    // corporateName: '话圆圈',
    // platformName: "易行者",
    // corporateName: '易行者',
    // platformName: "企信云",
    // corporateName: '企信云',

    // websocket: websocket,
    post(url, params) {
        return axios({
            method: 'POST',
            url,
            data: params
        })
    },
    get(url, params) {
        return axios({
            method: 'GET',
            url,
            params
        })
    },
    delete(url, params) {
        return axios({
            method: 'DELETE',
            url,
            data: params
        })
    },
    put(url, params) {
        return axios({
            method: 'PUT',
            url,
            data: params
        })
    },
    patch(url, params) {
        return axios({
            method: 'PATCH',
            url,
            data: params
        })
    },
}